import axios from 'axios';

import {CustomerLogo} from 'interfaces';
import {
    ChatGptSettings,
    ClaudeSettings,
    ClientSettings,
    ClientWhiteLabelSaveResultsType,
    DynamicContentComponent,
    LiveHelpSettings,
    WhiteLabelSettings
} from 'types';

import {API_URL} from './constants';

const updateIncomingMessageSoundSettings = async (data: {value: boolean}) => {
    const res = await axios.post(`${API_URL}/settings/user/incoming-message-sound`, data);
    return res.data;
};

const updateLanguageSettings = async (data: {value: string}) => {
    const res = await axios.post(`${API_URL}/settings/user/language`, data);
    return res.data;
};

const getRequestAppointmentRecipients = async (): Promise<{[key: string]: string[]}> => {
    const res = await axios.get(`${API_URL}/settings/request-appointment-recipients`);
    return res.data;
};

const getClientWhiteLabel = async (groupId: string): Promise<WhiteLabelSettings> => {
    const res = await axios.post(`${API_URL}/settings/get-client-white-label`, {groupId});
    return res.data;
};

const getClientSettings = async (groupId: string): Promise<ClientSettings> => {
    const res = await axios.post(`${API_URL}/settings/get-client-settings`, {groupId});
    return res.data;
};

const saveClientWhiteLabel = async (data: {groupId: string,
        components: DynamicContentComponent[]}): Promise<ClientWhiteLabelSaveResultsType> => {
    const res = await axios.post(`${API_URL}/settings/save-client-white-label`, data);
    return res.data;
};

const updateRequestAppointmentRecipients = async (recipients: string[], groupId: string) => {
    const res = await axios.post(`${API_URL}/settings/request-appointment-recipients`, {recipients, groupId});
    return res.data;
};

const getClientSessionCustomerLogo = async (): Promise<{account: CustomerLogo, groups: CustomerLogo[]}> => {
    const res = await axios.post(`${API_URL}/settings/client-session-customer-logo`);
    return res.data;
};

const updateClientSessionCustomerLogo = async ({account, groups}) => {
    const res = await axios.post(`${API_URL}/settings/update-client-session-customer-logo`, {account, groups});
    return res.data;
};

const fetchAgentsAvailability = async () => {
    const res = await axios.post(`${API_URL}/settings/client-session-agents-availability`);
    return res.data;
};

const updateAgentsAvailability = async (data: any) => {
    const res = await axios.post(`${API_URL}/settings/update-client-session-agents-availability`, data);
    return res.data;
};

const getLiveHelp = async (groupId: string): Promise<LiveHelpSettings> => {
    const res = await axios.post(`${API_URL}/settings/get-live-help`, {groupId});
    return res.data;
};

const updateLiveHelp = async (data: {groupId: string, liveHelp: Partial<LiveHelpSettings>}): Promise<LiveHelpSettings> => {
    const res = await axios.post(`${API_URL}/settings/update-live-help`, data);
    return res.data;
};

const addChatGptToLiveHelp = async (
    data: {labels: {chatGPT: string, requestAppointment: string, callAgent: string}}
): Promise<ChatGptSettings> => {
    const res = await axios.post(`${API_URL}/settings/add-chat-gpt-to-live-help`, data);
    return res.data;
};

const getChatGpt = async (name: string): Promise<ChatGptSettings> => {
    const res = await axios.post(`${API_URL}/settings/get-chat-gpt/${name}`);
    return res.data;
};

const updateChatGpt = async (name: string, data: {liveHelp: Partial<ChatGptSettings>}): Promise<ChatGptSettings> => {
    const res = await axios.post(`${API_URL}/settings/update-chat-gpt/${name}`, data);
    return res.data;
};

const getClaude = async (name: string): Promise<ClaudeSettings> => {
    const res = await axios.post(`${API_URL}/settings/get-claude/${name}`);
    return res.data;
};

const updateClaude = async (name: string, data: {claude: Partial<ClaudeSettings>}): Promise<ClaudeSettings> => {
    const res = await axios.post(`${API_URL}/settings/update-claude/${name}`, data);
    return res.data;
};

const getAvatarConfig = async (groupId: string): Promise<{host: string, url: string}> => {
    const res = await axios.post(`${API_URL}/settings/get-avatar-config`, {groupId});
    return res.data;
};

const updateAvatarConfig = async (data: {groupId: string, config: {host: string, url: string}}) => {
    const res = await axios.post(`${API_URL}/settings/update-avatar-config`, data);
    return res.data;
};

export const userSettingsApi = {
    updateIncomingMessageSoundSettings,
    updateLanguageSettings,
    getRequestAppointmentRecipients,
    updateRequestAppointmentRecipients,
    getClientSessionCustomerLogo,
    updateClientSessionCustomerLogo,
    fetchAgentsAvailability,
    updateAgentsAvailability,
    getClientWhiteLabel,
    saveClientWhiteLabel,
    getClientSettings,
    getLiveHelp,
    updateLiveHelp,
    getAvatarConfig,
    updateAvatarConfig,
    addChatGptToLiveHelp,
    getChatGpt,
    updateChatGpt,
    getClaude,
    updateClaude
};
